import React from "react"

import "./style.scss"

const data = {
    company: {
        name: "Demo Company",
        logo: "",
        email: "name@email.com",
        region: "Asia/Mumbai",
        subscription: "Plan A",
    }
}

const OrgSection = () => {

    return (
        <div className="organization-details-section">
            {/* <div className="title-section">Org Admin</div> */}
            <div className="company-section">
                <div className="company-logo">
                    <div>{data?.company?.name.charAt(0).toUpperCase() +
                        data?.company?.name.split(" ")[1].charAt(0).toUpperCase()}
                    </div>
                </div>
                <div className="company-card">
                    <div className="company-title">{"Organization Name"}</div>
                    <div className="company-description">{data?.company?.name}</div>
                </div>
            </div>
            <div className="company-details-section">
                <div className="detail-card">
                    <div className="detils-title">{"Email"}</div>
                    <div className="detils-description">{data?.company?.email}</div>
                </div>
                <div className="detail-card">
                    <div className="detils-title">{"Region"}</div>
                    <div className="detils-description">{data?.company?.region}</div>
                </div>
                <div className="detail-card">
                    <div className="detils-title">{"Subscription"}</div>
                    <div className="detils-description">{data?.company?.subscription}</div>
                </div>
                <div className="btn upgrade-btn">Upgrade Plan</div>
            </div>
        </div>
    )
}

export default OrgSection;